<template>
  <div class="page-content container">
    <div class="form-header-border">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <app-breadcrumbs></app-breadcrumbs>
          </div>
        </div>
        <div class="level-center">
          <div class="level-item has-text-weight-bold">
            {{ user.firstName }} {{ user.lastName }}
          </div>
        </div>
        <div class="level-right">
          <div v-if="user.userID && hasPermission([10003])" class="level-item">
            <button class="button" @click="deleteDialog = true">
              <span class="icon icon-delete"></span>
              <span>Delete</span>
            </button>
          </div>
          <div class="level-item">
            <button class="button" @click="submit">Save</button>
          </div>
        </div>
      </div>
    </div>

    <confirm-dialog
      v-model="deleteDialog"
      @confirmed="deleteUser"
    ></confirm-dialog>

    <validation-observer ref="formuser">
      <user-form v-model="user" :editing="editing"></user-form>
    </validation-observer>
  </div>
</template>

<script>
import _ from 'lodash';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import AppBreadcrumbs from '@/components/AppBreadcrumbs';
import UserForm from '@/components/forms/UserForm.vue';
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'UserShow',
  components: { ConfirmDialog, UserForm, ValidationObserver, AppBreadcrumbs },
  data() {
    return {
      user: {
        roles: [
          {
            roleID: null
          }
        ]
      },
      originalUser: {},
      editing: true,
      deleteDialog: false
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.axiosRequest('get', `Users/${this.$route.params.id}`)
        .then(response => {
          this.user = response.data;
          this.originalUser = _.cloneDeep(this.user);
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  },
  methods: {
    submit() {
      this.$refs.formuser.validate().then(success => {
        if (!success) {
          this.showErrorMessage('Please check the errors');
          return;
        } else {
          let method = 'post';
          let url = `Users`;
          let args = _.pick(this.user, [
            'userID',
            'firstName',
            'lastName',
            'email',
            'password'
          ]);
          if (this.user.userID != undefined) {
            method = 'put';
            url = `Users/${this.user.userID}`;
            args = _.pick(this.user, [
              'userID',
              'firstName',
              'lastName',
              'email'
            ]);
          }
          this.axiosRequest(method, url, args)
            .then(response => {
              this.showSuccessMessage('User saved');
              this.user = response.data;
            })
            .catch(error => {
              this.showErrorMessage(error);
            });
        }
      });
    },
    deleteUser() {
      this.axiosRequest('delete', `Users/${this.user.userID}`)
        .then(() => {
          this.$router.replace({ name: 'team' });
          this.deleteDialog = false;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss"></style>
